module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/btn_2_sp_2176c73c4b4dc914c931303243d64de0.png";